export function normalizeParticipantType(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  if (normalized.startsWith("med")) return "medico";
  return "colaborador";
}

function normalizeHeader(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

const typeHeaders = ["tipo", "categoria", "categoría", "rol", "medico o colaborador", "médico o colaborador"];
const professionalLicenseHeaders = [
  "colegiado",
  "numero colegiado",
  "número colegiado",
  "numero de colegiado",
  "número de colegiado",
  "no colegiado",
  "no. colegiado"
];
const employeeCodeHeaders = [
  "codigo",
  "código",
  "codigo colaborador",
  "código colaborador",
  "codigo de colaborador",
  "código de colaborador"
];

function splitCsvLine(line) {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const next = line[index + 1];
    if (char === '"' && next === '"') {
      current += '"';
      index += 1;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if ((char === "," || char === "\t") && !inQuotes) {
      values.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }

  values.push(current.trim());
  return values;
}

export function parseBulkUsers(input) {
  const lines = input
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const imported = [];
  const invalid = [];
  const seen = new Set();
  const firstColumns = splitCsvLine(lines[0] || "").map(normalizeHeader);
  const hasHeader = firstColumns.some((column) =>
    ["correo", "email", "password", "contrasena", "contraseña", "nombre", "name", ...typeHeaders].includes(column)
  );
  const headerIndex = Object.fromEntries(firstColumns.map((column, index) => [column, index]));

  const getByHeader = (columns, keys, fallbackIndex) => {
    const key = keys.find((candidate) => headerIndex[candidate] !== undefined);
    return columns[key ? headerIndex[key] : fallbackIndex]?.trim();
  };

  lines.forEach((line, index) => {
    if (hasHeader && index === 0) return;
    const columns = splitCsvLine(line);
    const email = getByHeader(columns, ["correo", "email"], 0);
    const password = getByHeader(columns, ["password", "contrasena", "contraseña"], 1);
    const name = getByHeader(columns, ["nombre", "name"], 2);
    const type = getByHeader(columns, typeHeaders.map(normalizeHeader), 3);
    const participantType = normalizeParticipantType(type);
    const professionalLicense = getByHeader(columns, professionalLicenseHeaders.map(normalizeHeader), 4);
    const employeeCode = getByHeader(columns, employeeCodeHeaders.map(normalizeHeader), 5);
    const emailLower = email?.toLowerCase();

    if (!name && !email) return;
    if (!name || !password || password.length < 6 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailLower || "")) {
      invalid.push({ line: index + 1, value: line });
      return;
    }

    if (seen.has(emailLower)) return;
    seen.add(emailLower);
    imported.push({ name, email: emailLower, password, participantType, professionalLicense, employeeCode });
  });

  return {
    rows: imported,
    invalid,
    duplicatesInPaste: Math.max(0, lines.length - (hasHeader ? 1 : 0) - imported.length - invalid.length)
  };
}

export const parseAuthorizedUsers = parseBulkUsers;

export function toCsv(rows, columns) {
  const escape = (value) => {
    const normalized = value === null || value === undefined ? "" : String(value);
    return `"${normalized.replaceAll('"', '""')}"`;
  };

  return [
    columns.map((column) => escape(column.label)).join(","),
    ...rows.map((row) => columns.map((column) => escape(row[column.key])).join(","))
  ].join("\n");
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
